var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* テンプレート表示画面 */
import React, { useState, useEffect, useCallback } from 'react';
import ReactDOM from 'react-dom';
import { handleBrowzerBack } from '../BrowzerBack';
import Text from '../molecules/Text';
import axios from '../axios';
import Moment from 'moment';
import ShelfInShelf from '../molecules/ShelfInShelf';
import Shelf from '../molecules/Shelf';
import DataList from '../molecules/DataList';
import Button from '../molecules/DefaultButton';
import RowDate from '../molecules/RowDate';
import Postcode from '../molecules/Postcode';
import Telnum from '../molecules/TelInput';
import NameInput from '../molecules/NameInput';
import RadioButton from '../molecules/RadioButton';
import CheckBox from '../molecules/CheckBox';
import Select from '../molecules/Select';
import TopArea from '../organisms/TopArea';
import TextArea from '../molecules/TextArea';
import Paragraph from '../atoms/Paragraph';
import EnclosedString from '../molecules/EnclosedString';
import LayoutDivision from '../molecules/LayoutDivision';
import YearMonth from '../molecules/InputYearMonth';
import Link from '../atoms/Link';
import Image from '../molecules/Image';
import RowFullJustifyButton from '../molecules/RowFullJustifyButton';
import RowJustifyButton from '../molecules/RowJustifyButton';
import RowLeftButton from '../molecules/RowLeftButton';
import RowRightButton from '../molecules/RowRightButton';
import RowCenterButton from '../molecules/RowCenterButton';
import RowLeftAndRightAlignmentButton from '../molecules/RowLeftAndRightAlignmentButton';
import ModalTemplate from '../molecules/ModalTemplate';
import FileUploadTemplate from '../organisms/FileUpload';
import FloatingMenu from '../organisms/FloatingMenu';
import FooterButtonShelf from '../molecules/FooterAreaButtons';
import ResponseDialog from '../molecules/ResponseDialog';
import TextWithSearch from '../molecules/TextWithSearch';
import SearchResultDialog from '../molecules/SearchResultDialog';
import BusinessDayCalendar from '../organisms/BusinessDayCalendar';
import AfterSpecifiedDateCalendar from '../organisms/AfterSpecifiedDateCalendar';
import PasswordReset from '../molecules/PasswordReset';
import { usePassword } from '../hooks/PasswordResetHooks';
import { tmp_init, api_response_type, convert_types, dialog_init, dialog_type, dialog_function, file_upload_label, shelf_type, fm_types, file_upload_info_init, valid_merge_index, scroll_option, download_wait_time, loding_close_timmer, exclusion_init, content_type, postcode_index, address_option, search_dialog_init, address_init, module_name, remark_field_id, } from '../Const';
import { convertData, removeComma } from '../Convert';
import { isBrowserIe } from '../BrowserJudgment';
import { scrollTargetElement } from '../Scroll';
import LoadingModal from '../organisms/LoadingModal';
import { fileDownload } from '../FileDownload';
import Password from '../molecules/Password';
import { editModalBody } from '../EditModal';
import { jumpUrl } from './../Common';
import { isBrowserIOSSafari, isBrowserIpadSafari } from '../BrowserJudgment';
import { releaseBrowzerBack } from '../BrowzerBack';
import { useTranslation } from 'react-i18next';
import { getLanguage } from '../Common';
import { useToggle } from '../hooks/ToggleHooks';
import { parse } from 'querystring';
var Reception = function () {
    // 親棚の状態
    var _a = useState([]), parent_shelfs = _a[0], setParentShelfs = _a[1];
    // 子棚の状態
    var _b = useState([]), child_shelfs = _b[0], setChildShelfs = _b[1];
    // 小棚内要素の状態
    var _c = useState([]), contents = _c[0], setContents = _c[1];
    // ヘッダーに表示する情報
    var _d = useState(''), reception_cd = _d[0], setReceptionCd = _d[1];
    var _e = useState(''), reception_sub_cd = _e[0], setReceptionSubCd = _e[1];
    var _f = useState(''), status = _f[0], setStatus = _f[1];
    var _g = useState(0), status_code = _g[0], setStatusCode = _g[1];
    var _h = useState(''), email = _h[0], setEmail = _h[1];
    var _j = useState(false), is_staff = _j[0], setIsStaff = _j[1];
    var _k = useState(0), reception_id = _k[0], setReceptionId = _k[1];
    var _l = useState(''), application_date = _l[0], setApplicationDate = _l[1];
    var _m = useState(''), application_product = _m[0], setApplicationProduct = _m[1];
    var _o = useState(''), user_name = _o[0], setUserName = _o[1];
    var _p = useState(''), user_kana_name = _p[0], setUserKanaName = _p[1];
    var _q = useState(''), mobile_phone_number = _q[0], setMobilePhoneNumber = _q[1];
    var _r = useState(''), phone_number = _r[0], setPhoneNumber = _r[1];
    var _s = useState(''), work_phone_number = _s[0], setWorkPhoneNumber = _s[1];
    var _t = useState(''), desired_contact = _t[0], setDesiredContact = _t[1];
    var _u = useState(''), contact_workplace_time = _u[0], setContactWorkplaceTime = _u[1];
    var _v = useState(''), contact_workplace_name = _v[0], setContactWorkplaceName = _v[1];
    var _w = useState(''), user_agent = _w[0], setUserAgent = _w[1];
    var _x = useState(''), parameter = _x[0], setParameter = _x[1];
    var _y = useState(false), mypage_status_opened = _y[0], setMypageStatusOpened = _y[1];
    var _z = useState(''), message = _z[0], setMessage = _z[1];
    var _0 = usePassword(''), password = _0[0], handleChangePassword = _0[1];
    var _1 = usePassword(''), password_confirmation = _1[0], handleChangePasswordConfirmation = _1[1];
    var _2 = useToggle(false), show_password_reset = _2[0], toggleShowPasswordReset = _2[1];
    var _3 = useState(false), is_operation_with_stl = _3[0], setIsOperationWithStl = _3[1];
    var _4 = useState(0), user_role_id = _4[0], setUserRoleId = _4[1];
    var _5 = useState(false), is_se_user = _5[0], setIsSeUser = _5[1];
    // 提出済み本人確認書類リスト
    var _6 = useState([]), file_upload_list = _6[0], setFileUploadList = _6[1];
    // ファイルアップロード情報
    var _7 = useState(file_upload_info_init), file_upload_info = _7[0], setFileUploadInfo = _7[1];
    var _8 = useState(false), file_upload_next_button_disabled = _8[0], setFileUploadNextButtonDisabled = _8[1];
    var _9 = useState(''), file_upload_next_button_function = _9[0], setFileUploadNextButtonFunction = _9[1];
    var _10 = useState(''), file_upload_message = _10[0], setFileUploadMessage = _10[1];
    // 返答ダイアログ状態
    var _11 = useState(dialog_init), response_dialog_state = _11[0], setResponseDialogState = _11[1];
    // 検索ダイアログ状態
    var _12 = useState(search_dialog_init), search_dialog_state = _12[0], setSearchDialogState = _12[1];
    // 住所選択状態
    var _13 = useState(address_init), address_state = _13[0], setAddressState = _13[1];
    // Ajax通信状態
    var _14 = useState(false), is_connecting = _14[0], setIsConnecting = _14[1];
    // ローディング画面表示状態
    var _15 = useState(false), is_loading = _15[0], setIsLoading = _15[1];
    // onChange発火フラグ
    var _16 = useState(false), changed = _16[0], setChanged = _16[1];
    // 排他情報
    var _17 = useState(exclusion_init), exclusion_info = _17[0], setExclusionInfo = _17[1];
    // 言語
    var _18 = useTranslation(), t = _18.t, i18n = _18.i18n;
    /**
     * テンプレート取得用のパスを生成する
     *
     * Note: 現在のURLからAPI取得用のURLを作成します。
     * 使用URLの変更等があった場合は修正必須です。
     * URL末尾 ⇒ reception_id 案件ID
     * URL末尾-1 ⇒ reception_cd 案件CD
     *
     * @return string テンプレート取得URL
     */
    var makePath = function () {
        var urls = location.pathname.split('/');
        var reception_id = urls.pop();
        var reception_cd = urls.pop();
        return "api/reception/" + reception_cd + "/" + reception_id;
    };
    /**
     * アップロードファイルデータ取得用のパスを生成する
     *
     * Note: 現在のURLからAPI取得用のURLを作成します。
     * 使用URLの変更等があった場合は修正必須です。
     * URL末尾 ⇒ reception_id 案件ID
     * URL末尾-1 ⇒ reception_cd 案件CD
     *
     * @return string テンプレート取得URL
     */
    var makePathFileUpload = function () {
        var urls = location.pathname.split('/');
        var reception_id = urls.pop();
        var reception_cd = urls.pop();
        return "api/reception/" + reception_cd + "/" + reception_id + "/file";
    };
    useEffect(function () {
        // ブラウザの戻る・進む禁止
        handleBrowzerBack();
        var get_queries = parse(location.search.slice(1));
        var is_view_mode = get_queries.view_mode === 'true';
        fetchReception(makePath() + '?view_mode=' + is_view_mode);
    }, []);
    /**
     * 案件詳細画面表示に必要なデータを再取得します。
     * エラー発生時はローディングを非表示にします。
     * @param url データ取得先url
     */
    var fetchReception = function (url) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    // 言語変更
                    i18n.changeLanguage(getLanguage());
                    return [4 /*yield*/, axios.get(url)];
                case 1:
                    response = _a.sent();
                    setParentShelfs(response.data.info.parent_blocks);
                    setChildShelfs(response.data.info.child_blocks);
                    setContents(response.data.info.contents);
                    setReceptionCd(response.data.info.headers.reception_cd);
                    setStatus(response.data.info.headers.status);
                    setStatusCode(response.data.info.headers.status_code);
                    setEmail(response.data.info.headers.mypage_id);
                    setIsStaff(response.data.info.headers.is_staff);
                    setReceptionId(response.data.info.headers.reception_id);
                    setReceptionSubCd(response.data.info.headers.reception_sub_cd);
                    setApplicationDate(response.data.info.headers.application_date);
                    setApplicationProduct(response.data.info.headers.application_product);
                    setUserName(response.data.info.headers.user_name);
                    setUserKanaName(response.data.info.headers.user_kana_name);
                    setMobilePhoneNumber(response.data.info.headers.mobile_phone_number);
                    setPhoneNumber(response.data.info.headers.phone_number);
                    setWorkPhoneNumber(response.data.info.headers.phone_number);
                    setDesiredContact(response.data.info.headers.desired_contact);
                    setContactWorkplaceTime(response.data.info.headers.desired_contact_time);
                    setContactWorkplaceName(response.data.info.headers.contact_workplace_name);
                    setUserAgent(response.data.info.headers.user_agent);
                    setParameter(response.data.info.headers.parameter);
                    setMessage(response.data.info.headers.message);
                    setMypageStatusOpened(response.data.info.mypage_status_opened);
                    setIsOperationWithStl(response.data.info.operation_authority);
                    setUserRoleId(response.data.info.user_role_id);
                    setIsSeUser(response.data.info.is_se_user);
                    /*
                    NOTE:ファイルアップロード機能を追加する予定ないのでコメントアウト
                     setFileUploadList(response.data.info.file_upload.init);
                     setFileUploadInfo(response.data.info.file_upload.info);
                     setFileUploadNextButtonDisabled(response.data.info.file_upload.next_button_disabled);
                     setFileUploadNextButtonFunction(response.data.info.file_upload.next_button_function);
                     getPreview(response.data.info.file_upload.init);
                     */
                    setExclusionInfo(response.data.info.exclusion_info);
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error(error_1);
                    // エラーメッセージを表示後、案件一覧に遷移する
                    alert(error_1.response.data.message);
                    location.replace("" + location.origin + process.env.MIX_MOCK_URL);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    /**
     * プレビュー表示する画像を非同期で取得する
     *
     * @param {Array<FileUpload>} file_upload_list ファイル情報
     */
    var getPreview = function (file_upload_list) { return __awaiter(void 0, void 0, void 0, function () {
        var array, response, result_array;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    array = file_upload_list.map(function (data) {
                        return data.file_label;
                    });
                    return [4 /*yield*/, axios.post(makePathFileUpload(), array)];
                case 1:
                    response = _a.sent();
                    result_array = file_upload_list.map(function (data, index) {
                        return __assign(__assign({}, data), { preview_file_src: response.data[index] });
                    });
                    setFileUploadList(result_array);
                    return [2 /*return*/];
            }
        });
    }); };
    /**
     * 親の棚を作成
     * Note: 棚種別は 2, 3, 4以外不要
     * @return JSX.Element[]
     */
    var createParentBlock = function () {
        // 初期表示用条件
        return parent_shelfs.map(function (parent_shelf) {
            switch (parent_shelf.pb_kind) {
                case shelf_type.shelf: // アコーディオン出力
                    return (React.createElement(Shelf, { key: parent_shelf.pb_id, label: parent_shelf.pb_display_name, is_open: parent_shelf.pb_open, handleClick: function () { return toggleParentShelf(parent_shelf.pb_id); }, is_click_disabled: is_se_user }, createChildBlock(parent_shelf.pb_id)));
                case shelf_type.layout_divisiton: // レイアウト用論理棚
                    return (React.createElement(LayoutDivision, { key: parent_shelf.pb_id }, createChildBlock(parent_shelf.pb_id)));
                case shelf_type.fragment: // domを出力しない棚
                    return (React.createElement(React.Fragment, { key: parent_shelf.pb_id }, createChildBlock(parent_shelf.pb_id)));
                default:
                    return;
            }
        });
    };
    /**
     * 親棚を開閉する
     *
     * @param parent_id 親棚のid
     */
    var toggleParentShelf = function (parent_id) {
        setParentShelfs(function (prev) {
            // 対象親棚のindex取得
            var current_index = prev.findIndex(function (value) { return value.pb_id === parent_id; });
            // ディープコピー
            var array = prev.slice();
            array[current_index].pb_open = !prev[current_index].pb_open;
            return array;
        });
    };
    /**
     * 子の棚を作成
     * @param parent_id 親棚のid
     * @return JSX.Element[]
     */
    var createChildBlock = function (parent_id) {
        return child_shelfs.map(function (child_shelf) {
            if (parent_id !== child_shelf.pb_id) {
                return;
            }
            switch (child_shelf.cb_kind) {
                case shelf_type.header: // ヘッダー01
                    return (React.createElement(TopArea, { key: child_shelf.key, is_staff: is_staff, changed: changed, t: t, handleClick: handleClickPostRemark, is_operation_with_stl: is_operation_with_stl, clickReceptionHistory: clickReceptionHistory, login_user_role_id: user_role_id }));
                case shelf_type.shelf: // アコーディオン出力
                    return (React.createElement(ShelfInShelf, { key: child_shelf.key, id: child_shelf.key, label: child_shelf.cb_display_name, is_open: child_shelf.cb_open, handleClick: function () { return toggleChildShelf(child_shelf.pb_id, child_shelf.cb_id); }, is_click_disabled: is_se_user }, createContents(child_shelf.pb_id, child_shelf.cb_id)));
                case shelf_type.layout_divisiton: // レイアウト用論理棚
                    return (React.createElement(LayoutDivision, { key: child_shelf.key }, createContents(child_shelf.pb_id, child_shelf.cb_id)));
                case shelf_type.fragment: // domを出力しない棚
                    return (React.createElement(React.Fragment, { key: child_shelf.key }, createContents(child_shelf.pb_id, child_shelf.cb_id)));
                case shelf_type.footer: // 案件一覧に戻るボタン表示
                    // マイページ未開設時は非表示
                    // 変更があった場合のみダイアログを開く
                    return (mypage_status_opened && (React.createElement(FooterButtonShelf, { key: child_shelf.key, is_staff: is_staff, is_on_change: changed })));
                case shelf_type.full_justify_buttons: // ボタン左右中央寄せ
                    return (React.createElement(RowFullJustifyButton, { key: child_shelf.key }, createContents(child_shelf.pb_id, child_shelf.cb_id)));
                case shelf_type.left_button: // ボタン左寄せ
                    return (React.createElement(RowLeftButton, { key: child_shelf.key }, createContents(child_shelf.pb_id, child_shelf.cb_id)));
                case shelf_type.center_button: // ボタン中央寄せ
                    return (React.createElement(RowCenterButton, { key: child_shelf.key }, createContents(child_shelf.pb_id, child_shelf.cb_id)));
                case shelf_type.right_button: // ボタン右寄せ
                    return (React.createElement(RowRightButton, { key: child_shelf.key }, createContents(child_shelf.pb_id, child_shelf.cb_id)));
                case shelf_type.justify_buttons: // ボタン均等割付
                    return (React.createElement(RowJustifyButton, { key: child_shelf.key }, createContents(child_shelf.pb_id, child_shelf.cb_id)));
                case shelf_type.left_and_right_alignment_buttons: // ボタン左右揃え
                    return (React.createElement(RowLeftAndRightAlignmentButton, { key: child_shelf.key }, createContents(child_shelf.pb_id, child_shelf.cb_id)));
                case shelf_type.documents: // 書類提出（子）
                    return (file_upload_list.length !== 0 && (React.createElement(ShelfInShelf, { key: child_shelf.key, id: child_shelf.key, label: file_upload_label.identification, is_open: child_shelf.cb_open, handleClick: function () { return toggleChildShelf(child_shelf.pb_id, child_shelf.cb_id); } }, createFileUpload(file_upload_list, child_shelf.block_disabled, child_shelf.pb_id, child_shelf.cb_id))));
                default:
                    return;
            }
        });
    };
    /**
     * 子棚を開閉する
     *
     * @param parent_id 親棚のid
     * @param child_id 子棚のid
     * @param is_open 開閉フラグ（true:開,false:閉）
     */
    var toggleChildShelf = function (parent_id, child_id, is_open) {
        setChildShelfs(function (prev) {
            // 対象子棚のindex取得
            var current_index = prev.findIndex(function (value) { return value.pb_id === parent_id && value.cb_id === child_id; });
            // 対象子棚の開閉状態を設定
            var cb_open = typeof is_open === 'undefined' ? !prev[current_index].cb_open : is_open;
            // ディープコピー
            var array = prev.slice();
            array[current_index].cb_open = cb_open;
            return array;
        });
    };
    /**
     * 次の小棚を見つける
     * 同じ親棚に所属していない場合, 次の棚が無い場合は0を返す
     *
     * @param cb_id 小棚のid
     */
    var findNextChidShelf = function (cb_id) {
        var current_index = child_shelfs.findIndex(function (child_shelf) { return child_shelf.cb_id === cb_id; });
        var next_index = child_shelfs.findIndex(function (child_shelf) { return child_shelf.cb_id === cb_id; }) + 1;
        if (typeof child_shelfs[current_index] !== 'undefined' &&
            typeof child_shelfs[next_index] !== 'undefined' &&
            child_shelfs[current_index].pb_id === child_shelfs[next_index].pb_id) {
            return child_shelfs[next_index].cb_id;
        }
        else {
            return 0;
        }
    };
    /**
     * 次の棚へスクロールする
     *
     * @param parent_id 親棚id
     * @param next_child_id 次へボタンを押下した棚のid
     */
    var scrollToNextShelf = function (parent_id, next_child_id) {
        var current_index = child_shelfs.findIndex(function (value) { return value.pb_id === parent_id && value.cb_id === next_child_id; });
        var target_shelf_id = child_shelfs[current_index].key;
        var element = document.getElementById(target_shelf_id);
        scrollTargetElement(element, scroll_option.next_shelf);
    };
    /**
     * ボタン押下時にダイアログを表示する
     *
     * @param fm_id フィールドマスタのid
     */
    var toggleDialog = function (fm_id) {
        setContents(function (prev) {
            var index = prev.findIndex(function (value) { return value.fm_id === fm_id && !value.disabled; });
            var array = prev.slice(); // ディープコピー
            array[index].dialog_is_open = !array[index].dialog_is_open;
            return array;
        });
    };
    /**
     * ファンクション前の確認ダイアログの表示非表示を判定
     *
     * @param content 表示コンテンツ情報
     */
    var isConfirmationDialog = function (content) {
        //ダイアログの確認画面有無区分が有の場合、ダイアログ表示用ボタンとモーダルを作成する。
        if (content.dialog) {
            return (React.createElement("div", { key: content.key },
                React.createElement(Button, { label: content.fm_display_name, strong: false, handleClick: function () { return toggleDialog(content.fm_id); }, disabled: content.disabled, show: !content.disabled }),
                React.createElement(ModalTemplate, { show: content.dialog_is_open, title: content.dialog_title, body: editModalBody(content.dialog_msg), ClickCallBackNo: function () {
                        toggleDialog(content.fm_id);
                    }, ClickCallBackYes: function () {
                        joinEventFiredOnce(function () {
                            toggleDialog(content.fm_id);
                            requestModule(content.is_send_parent, content.function, content.pb_id, content.cb_id);
                        });
                    }, t: t })));
        }
        else {
            //ダイアログの確認画面有無区分が無の場合、ボタンを作成する。
            return (React.createElement(Button, { key: content.key, label: content.fm_display_name, strong: false, handleClick: function (event) {
                    content.function === 'TransitionChangeLog'
                        ? clickReceptionHistory(event)
                        : joinEventFiredOnce(function () {
                            return requestModule(content.is_send_parent, content.function, content.pb_id, content.cb_id);
                        });
                }, disabled: content.disabled, show: !content.disabled }));
        }
    };
    /**
     * 小の棚内に表示する要素を決定
     * @param pb_id 親の棚のid
     * @param cb_id 子の棚のid
     * @return JSX.Element[]
     */
    var createContents = function (pb_id, cb_id) {
        var tmp_year = [tmp_init];
        var tmp_sei = [tmp_init];
        return contents.map(function (content, index) {
            var _a, _b;
            if (cb_id !== content.cb_id || pb_id !== content.pb_id) {
                return;
            }
            switch (content.fm_type) {
                case fm_types.text: // テキストボックス表示
                case fm_types.number: // 数字入力欄表示
                case fm_types.not_yet_text: // テキストボックス表示(値が設定されている場合：済・nullの場合：未)
                    return (React.createElement(Text, { key: content.key, id: content.key, fm_id: content.fm_id, label: content.fm_display_name, placeholder: content.placeholder, value: content.value, need: content.required_mark, message: content.message, name: content.field_column_name, handleChange: handleChange, suffix: content.suffix, help_msg: content.help_msg, disabled: content.disabled, readonly: content.readonly, maxlength: content.maxlength, handleFocus: function () {
                            return handleFocus(content.fm_id, content.value, content.input_assistance);
                        }, handleBlur: function () {
                            handleBlurCallApi(content.fm_id, content.value, content.input_assistance, content.is_send_parent, content.function, content.pb_id, content.cb_id);
                        }, add_comma: content.input_assistance === convert_types.add_comma ? true : false, input_assistance: content.input_assistance }));
                case fm_types.date: // Datepicker表示
                    return (React.createElement(RowDate, { key: content.key, id: content.key, label: content.fm_display_name, need: content.required_mark, message: content.message, value: content.value !== null && content.value !== ''
                            ? new Date(Moment(content.value).format('YYYY/MM/DD'))
                            : null, name: content.field_column_name, placeholder: content.placeholder, help_msg: content.help_msg, disabled: content.disabled, readOnly: content.readonly, handleChange: function (date) {
                            handleChangeInput(date, content.fm_id);
                        }, handleBlur: function () {
                            handleBlurForDate(content, content.value);
                        }, handleCalendarClose: function () {
                            handleBlurForDate(content, content.value);
                        } }));
                case fm_types.business_date: // BusinessDayCalendar表示（申込人：借入希望日）
                    return (React.createElement(BusinessDayCalendar, { key: content.key, id: content.key, label: content.fm_display_name, need: content.required_mark, message: content.message, value: content.value !== null && content.value !== ''
                            ? new Date(Moment(content.value).format('YYYY/MM/DD'))
                            : null, name: content.field_column_name, placeholder: content.placeholder, help_msg: content.help_msg, disabled: content.disabled, handleChange: function (date) {
                            handleChangeInput(date, content.fm_id);
                            // TODO wakasugi.y 日付選択時にonBlurが発生しないため、onChangeでバリデーションを実行する(Githubにissueあり)
                            // https://github.com/Hacker0x01/react-datepicker/issues/2028
                            validationCheck(content.fm_id, date !== null ? Moment(date).format('YYYY-MM-DD') : '', content.input_assistance);
                        }, handleBlur: function () {
                            handleBlur(content.fm_id, content.value !== null && content.value !== ''
                                ? Moment(content.value).format('YYYY-MM-DD')
                                : content.value, content.input_assistance);
                        } }));
                case fm_types.after_specified_date: // ApplicationDateCalendar表示（行員：借入希望日）
                    return (React.createElement(AfterSpecifiedDateCalendar, { key: content.key, id: content.key, label: content.fm_display_name, need: content.required_mark, message: content.message, value: content.value !== null && content.value !== ''
                            ? new Date(Moment(content.value).format('YYYY/MM/DD'))
                            : null, name: content.field_column_name, placeholder: content.placeholder, help_msg: content.help_msg, disabled: content.disabled, minDate: application_date !== null &&
                            typeof application_date !== 'undefined' &&
                            application_date.length > 0
                            ? new Date(application_date)
                            : undefined, handleChange: function (date) {
                            handleChangeInput(date, content.fm_id);
                            // TODO wakasugi.y 日付選択時にonBlurが発生しないため、onChangeでバリデーションを実行する(Githubにissueあり)
                            // https://github.com/Hacker0x01/react-datepicker/issues/2028
                            validationCheck(content.fm_id, date !== null ? Moment(date).format('YYYY-MM-DD') : '', content.input_assistance);
                        }, handleBlur: function () {
                            handleBlur(content.fm_id, content.value !== null && content.value !== ''
                                ? Moment(content.value).format('YYYY-MM-DD')
                                : content.value, content.input_assistance);
                        } }));
                case fm_types.button: // ボタン表示
                    return isConfirmationDialog(content);
                case fm_types.postcode: // 郵便番号表示
                    return (React.createElement(Postcode, { id: content.key, key: content.key, label: content.fm_display_name, need: content.required_mark, value: content.value, clickCallback: function () {
                            return handleClickSearch(content.function, content.fm_id, content.field_column_name, content.value, content.pb_id, content.cb_id);
                        }, handleChangePostCode1: function (event) {
                            handleChangePostCode(event.target.value, content.fm_id, content.value, postcode_index.first);
                        }, handleChangePostCode2: function (event) {
                            handleChangePostCode(event.target.value, content.fm_id, content.value, postcode_index.last);
                        }, handleBlurPostCode1: function () {
                            handleBlurPostCode(content.fm_id, content.value, content.input_assistance, postcode_index.first);
                        }, handleBlurPostCode2: function () {
                            handleBlurPostCode(content.fm_id, content.value, content.input_assistance, postcode_index.last);
                        }, message: content.message, help_msg: content.help_msg, disabled: content.disabled }));
                case fm_types.telnumber: // 電話番号
                    return (React.createElement(Telnum, { key: content.key, label: content.fm_display_name, value: ['', '', ''], need: content.required_mark, message: content.message, help_msg: content.help_msg, disabled: content.disabled }));
                case fm_types.sei: // 姓
                    tmp_sei[index] = content;
                    break;
                case fm_types.mei: // 名
                    return (React.createElement(NameInput, { key: content.key, first_id: content.key, last_id: tmp_sei[index - 1].key, label: tmp_sei[index - 1].fm_display_name, need: content.required_mark, first_name: content.field_column_name, last_name: tmp_sei[index - 1].field_column_name, first_placeholder: content.placeholder, last_placeholder: tmp_sei[index - 1].placeholder, first_value: content.value, last_value: tmp_sei[index - 1].value, first_maxlength: content.maxlength, last_maxlength: tmp_sei[index - 1].maxlength, handleChangeFirstName: function (event) {
                            return handleChangeInput(event.target.value, content.fm_id);
                        }, handleChangeLastName: function (event) {
                            return handleChangeInput(event.target.value, tmp_sei[index - 1].fm_id);
                        }, message: (_a = tmp_sei[index - 1].message) !== null && _a !== void 0 ? _a : content.message, help_msg: content.help_msg, first_disabled: content.disabled, last_disabled: tmp_sei[index - 1].disabled, handleBlurFirstName: function () {
                            handleBlur(content.fm_id, content.value, content.input_assistance);
                        }, handleBlurLastName: function () {
                            handleBlur(tmp_sei[index - 1].fm_id, tmp_sei[index - 1].value, tmp_sei[index - 1].input_assistance);
                        } }));
                case fm_types.radio: // ラジオボタン
                    return (React.createElement(RadioButton, { key: content.key, id: content.key, label: content.fm_display_name, need: content.required_mark, name: content.key, value: content.value, sources: content.sources, handleChange: function (event) {
                            return handleChangeInput(event.target.value, content.fm_id);
                        }, message: content.message, help_msg: content.help_msg, disabled: content.disabled, handleBlur: function () {
                            handleBlur(content.fm_id, content.value, content.input_assistance);
                        } }));
                case fm_types.checkbox: //チェックボックス
                    return (React.createElement(CheckBox, { key: content.key, id: content.key, label: content.fm_display_name, need: content.required_mark, name: content.field_column_name, value: content.value, sources: content.sources, handleChange: function (event) {
                            return handleChangeCheck(event.target.value, event.target.checked, content.fm_id, content.value);
                        }, message: content.message, help_msg: content.help_msg, disabled: content.disabled }));
                case fm_types.select: // セレクトボックス
                case fm_types.items: // 商品選択
                case fm_types.se_country_select: // 居住国(SE権限)
                case fm_types.single_select: // セレクトボックス（選択肢1つ）
                    return (React.createElement(Select, { key: content.key, id: content.key, label: content.fm_display_name, need: content.required_mark, name: content.field_column_name, value: content.value, sources: content.sources, handleChange: function (event) {
                            handleChangeInput(event.target.value, content.fm_id);
                        }, message: content.message, help_msg: content.help_msg, disabled: content.disabled, suffix: content.suffix, 
                        // Note 画面上の値を全てリクエストに含める
                        handleBlur: function () {
                            handleBlurCallApi(content.fm_id, content.value, content.input_assistance, true, content.function, content.pb_id, content.cb_id);
                        }, with_empty_option: content.fm_type === fm_types.se_country_select }));
                case fm_types.textarea: // テキストエリア
                    return (React.createElement(TextArea, { id: content.key, key: content.key, fm_id: content.fm_id, label: content.fm_display_name, need: content.required_mark, name: content.field_column_name, value: content.value, handleChange: handleChange, placeholder: content.placeholder, message: content.message, help_msg: content.help_msg, disabled: content.disabled, handleBlur: function () {
                            handleBlur(content.fm_id, content.value, content.input_assistance);
                        }, maxlength: content.maxlength }));
                case fm_types.paragraph: // Pタグ文章
                    return (React.createElement(Paragraph, { key: content.key, label: content.fm_display_name, color: content.color, bold: content.bold }));
                case fm_types.paragraph2: // 囲み付き文字列
                    return (React.createElement(EnclosedString, { key: content.key, label: content.fm_display_name, color: content.color, bold: content.bold }));
                case fm_types.year: // 年
                    tmp_year[index] = content;
                    break;
                case fm_types.month: // 月
                    return (React.createElement(YearMonth, { key: content.key, year_id: tmp_year[index - 1].key, month_id: content.key, label: tmp_year[index - 1].fm_display_name, need: content.required_mark, year_name: tmp_year[index - 1].field_column_name, month_name: content.field_column_name, year_suffix: tmp_year[index - 1].suffix, month_suffix: content.suffix, year_placeholder: tmp_year[index - 1].placeholder, year: tmp_year[index - 1].value, month: content.value, year_maxlength: tmp_year[index - 1].maxlength, help_msg: tmp_year[index - 1].help_msg, year_disabled: tmp_year[index - 1].disabled, month_disabled: content.disabled, message: (_b = tmp_year[index - 1].message) !== null && _b !== void 0 ? _b : content.message, handleChangeYear: function (event) {
                            return handleChangeInput(event.target.value, tmp_year[index - 1].fm_id);
                        }, handleChangeMonth: function (event) {
                            return handleChangeInput(event.target.value, content.fm_id);
                        }, handleBlurYear: function () {
                            handleBlur(tmp_year[index - 1].fm_id, tmp_year[index - 1].value, tmp_year[index - 1].input_assistance);
                        }, handleBlurMonth: function () {
                            handleBlur(content.fm_id, content.value, content.input_assistance);
                        }, sources: content.sources }));
                case fm_types.link: // リンク
                    return (React.createElement(Link, { key: content.key, anchor: content.value, display_name: content.fm_display_name }));
                case fm_types.image: // 画像
                    return React.createElement(Image, { key: content.key, value: content.value });
                case fm_types.pincode: // PINコード表示
                    return (React.createElement(Password, { fm_id: content.fm_id, key: content.key, id: content.key, label: content.fm_display_name, placeholder: content.placeholder, value: content.value, need: content.required_mark, message: content.message, name: content.field_column_name, handleChange: handleChange, help_msg: content.help_msg, disabled: content.disabled, maxlength: content.maxlength, handleBlur: function () {
                            handleBlurCallApi(content.fm_id, content.value, content.input_assistance, content.is_send_parent, content.function, content.pb_id, content.cb_id);
                        }, visible_type: "number" }));
                case fm_types.datalist: // サジェスト付きセレクトボックス
                    return (React.createElement(DataList, { fm_id: content.fm_id, key: content.key, id: content.key, handleChange: handleChange, disabled: content.disabled, label: content.fm_display_name, value: content.value, sources: content.sources, help_msg: content.help_msg, message: content.message, need: content.required_mark, handleBlur: function () {
                            handleBlurCallApi(content.fm_id, content.value, content.input_assistance, content.is_send_parent, content.function, content.pb_id, content.cb_id);
                        }, maxlength: content.maxlength }));
                case fm_types.text_with_search: // 検索ボタン付きテキスト入力欄
                    return (React.createElement(TextWithSearch, { fm_id: content.fm_id, key: content.key, id: content.key, disabled: content.disabled, label: content.fm_display_name, value: content.value, help_msg: content.help_msg, message: content.message, need: content.required_mark, handleBlur: function () {
                            handleBlur(content.fm_id, content.value, content.input_assistance);
                        }, handleChange: function (event) {
                            handleChangeInput(event.target.value, content.fm_id);
                        }, handleClick: function () {
                            return handleClickSearch(content.function, content.fm_id, content.field_column_name, content.value, content.pb_id, content.cb_id);
                        }, maxlength: content.maxlength }));
                case fm_types.password_reset: // パスワードリセット
                    return (React.createElement(Button, { key: content.key, label: content.fm_display_name, strong: false, handleClick: toggleShowPasswordReset, disabled: content.disabled, show: !content.disabled }));
                default:
                    break;
            }
        });
    };
    /**
     * 書類提出（子）の棚内に表示する要素を作成
     * @param id 子の棚のid
     * @return JSX.Element[]
     */
    //todo degawa 引数を適切な型に修正
    var createFileUpload = function (file_upload_list, block_disabled, pb_id, cb_id) {
        if (file_upload_list !== null &&
            file_upload_list !== undefined &&
            file_upload_list.length > 0) {
            //初期表示データの編集
            var edit_file_upload_list = file_upload_list.map(function (item) {
                return __assign(__assign({}, item), { is_staff: is_staff });
            });
            return (React.createElement(FileUploadTemplate, { files_upload: edit_file_upload_list, setFilesUpload: setFileUploadList, files_upload_info: file_upload_info, block_disabled: block_disabled, handleNextButtonClick: function () {
                    return joinEventFiredOnce(function () {
                        return requestModuleForFileUpload(false, file_upload_next_button_function, pb_id, cb_id);
                    });
                }, next_button_disabled: file_upload_next_button_disabled, file_upload_message: file_upload_message, t: t }));
        }
        else {
            return React.createElement(React.Fragment, null);
        }
    };
    /**
     * 郵便番号の変更値をstateに保存する
     * 対応項目：Postcode
     *
     * @param changed_value 変更した値
     * @param fm_id 対象のid
     * @param values 現在の値
     * @param array_index 対応するindex値
     */
    var handleChangePostCode = function (changes_value, fm_id, values, array_index) {
        // 値の変更
        values[array_index] = changes_value;
        handleChangeInput(values, fm_id);
    };
    /**
     * 検索ボタン押下時処理
     * @param module_name 通信対象モジュール名
     * @param fm_id フィールドマスタのid
     * @param field_column_name 項目名
     * @param value: 郵便番号の配列,
     * @param pb_id: 親棚ID,
     * @param  cb_id: 子棚ID
     * @returns void
     */
    var handleClickSearch = function (module_name, fm_id, field_column_name, value, pb_id, cb_id) {
        var post_data = {
            reception_id: reception_id,
            reception_cd: reception_cd,
            module_name: module_name,
            status: status_code,
            is_json: true,
            detail: [
                {
                    id: fm_id,
                    name: field_column_name,
                    value: Array.isArray(value) ? value.join('') : value,
                },
            ],
        };
        postData(post_data, pb_id, cb_id, true);
    };
    /**
     * 郵便番号のBlurイベントハンドラ
     * 対応項目：Postcode
     *
     * @param fm_id 対象のid
     * @param values 現在の値fm_id
     * @param input_assistance 入力補助種別
     * @param array_index 対応するindex値
     */
    var handleBlurPostCode = function (fm_id, values, input_assistance, array_index) {
        // 入力値変換
        var convert_data = convertData(input_assistance, values[array_index]);
        values[array_index] = convert_data;
        setContents(function (prev) {
            return prev.map(function (value) {
                return value.fm_id === fm_id && !value.disabled
                    ? __assign(__assign({}, value), { value: values }) : value;
            });
        });
        // 両項目に値が入っている場合は結合してバリデーションを行う
        var post_date = values[postcode_index.first] && values[postcode_index.last] ? values.join('') : convert_data;
        // バリデーションチェック
        validationCheck(fm_id, post_date, input_assistance);
    };
    /**
     * 項目のフォーカスアウト時の処理（日付項目のみ対象）
     *
     * @param content 画面表示情報
     * @param value 値
     */
    var handleBlurForDate = function (content, value) {
        var target_value = value !== null && content.value !== ''
            ? Moment(content.value).format('YYYY-MM-DD')
            : content.value;
        // 入力値変換
        var convert_data = convertInputData(content.fm_id, target_value, content.input_assistance);
        // バリデーションチェック
        validationCheck(content.fm_id, convert_data, content.fm_type).then(function (res) {
            // validである、かつfuncがnullでもundefinedでも0文字でもなければAPIをキックする
            if (res &&
                content.function !== null &&
                typeof content.function !== 'undefined' &&
                content.function.length > 0) {
                var post_data = {
                    detail: [
                        {
                            id: content.fm_id,
                            value: convert_data,
                            name: content.field_column_name,
                        },
                    ],
                    module_name: content.function,
                    reception_id: reception_id,
                    reception_cd: reception_cd,
                    status: status_code,
                    is_json: true,
                };
                postData(post_data, content.pb_id, content.cb_id, false, false);
            }
        });
    };
    /**
     * 各項目入力値をstateに保存する
     * 対応項目：Text, TextArea
     * Note: 実装としてはこちらがベストな方法。
     * 全コンポーネントのコールバックをこの実装に変更する。
     *
     * @param event チェンジイベント
     */
    var handleChange = useCallback(function (event) {
        var fm_id = Number(event.currentTarget.dataset.fm_id);
        var event_value = event.target.value;
        setContents(function (prev) {
            var index = prev.findIndex(function (value) { return value.fm_id === fm_id && !value.disabled; });
            var array = prev.slice(); // ディープコピー
            array[index].value = event_value;
            return array;
        });
        // onChangeイベント発火フラグOn
        setChanged(true);
    }, [setContents]);
    /**
     * 各項目入力値をstateに保存する
     * 対応項目：Name, Text, Number, RadioButton, SELECT, Date, TextArea, YearMonth
     *
     * @param event_value 入力値
     * @param fm_id 対象のフィールドマスタid
     */
    var handleChangeInput = function (event_value, fm_id) {
        setContents(function (prev) {
            var index = prev.findIndex(function (value) { return value.fm_id === fm_id && !value.disabled; });
            var array = prev.slice(); // ディープコピー
            // 対象の値を変更
            array[index].value = event_value;
            return array;
        });
        // onChangeイベント発火フラグOn
        setChanged(true);
    };
    /**
     * 項目のフォーカスアウト時の処理
     * @param id 項目ID
     * @param value 項目の入力値
     * @param type 項目の変換タイプ
     */
    var handleBlur = function (id, value, type) {
        // 入力値変換
        var convert_data = convertInputData(id, value, type);
        // バリデーションチェック
        validationCheck(id, convert_data, type);
    };
    /**
     * 項目のフォーカスイン時の処理(カンマ除去)
     * @param fm_id フィールドマスタのid
     * @param input_value 入力値
     * @param type 項目の変換タイプ
     */
    var handleFocus = function (fm_id, input_value, type) {
        setContents(function (prev) {
            var index = prev.findIndex(function (value) { return value.fm_id === fm_id && !value.disabled; });
            var array = prev.slice(); // ディープコピー
            // 数値変換適用値
            var converted_value = removeComma(input_value, type);
            // 対象の値を変更
            array[index].value = converted_value;
            return array;
        });
    };
    /**
     * 項目のフォーカスアウト時の処理（APIコールあり）
     * FIXME sakuma:所属している棚の全入力値をPOSTする不具合アリ。要修正
     *
     * @param id 項目ID
     * @param value 項目の入力値
     * @param type 項目の変換タイプ
     * @param is_send_parent post対象の指定
     * @param func コールするファンクション
     * @param pb_id 親棚のid
     * @param cb_id 子棚のid
     */
    var handleBlurCallApi = function (id, value, type, is_send_parent, func, pb_id, cb_id) {
        // 入力値変換
        var convert_data = convertInputData(id, value, type);
        // バリデーションチェック
        validationCheck(id, convert_data, type).then(function (res) {
            // validである、かつfuncがnullでもundefinedでも0文字でもなければAPIをキックする
            if (res && func !== null && typeof func !== 'undefined' && func.length > 0) {
                requestModule(is_send_parent, func, pb_id, cb_id);
            }
        });
    };
    /**
     * チェックボックスの変更値をstateに保存する
     * 対応項目：Checkbox
     *
     * @param changed_value チェックした値
     * @param is_checked 現在のチェック状態
     * @param name 対象のname属性
     * @param velus 現在の値
     */
    var handleChangeCheck = function (checked_value, is_checked, fm_id, values) {
        // 値の変更
        if (is_checked) {
            values.push(checked_value);
        }
        else {
            values = values.filter(function (value) { return value !== checked_value; });
        }
        values.sort();
        handleChangeInput(values, fm_id);
    };
    /**
     * 送信する値を厳選, 変換する
     * @param is_send_parent post対象の指定
     * @param pb_id 親棚のid
     * @param cb_id 子棚のid
     */
    var convertPostData = function (is_send_parent, pb_id, cb_id) {
        // 送信データを取得
        return contents
            .filter(function (content) {
            if (is_send_parent) {
                return content.pb_id === pb_id && !content.disabled && content.field_column_name !== null;
            }
            else {
                return content.cb_id === cb_id && !content.disabled && content.field_column_name !== null;
            }
        })
            .map(function (data) {
            // POSTする値を適切な形に変換する
            var date_types = [fm_types.date, fm_types.business_date, fm_types.after_specified_date];
            // 郵便番号以外を対象にデータ変換
            var convert_data = data.fm_type === fm_types.postcode
                ? data.value
                : convertData(data.input_assistance, data.value);
            var post_value = data.fm_type === fm_types.checkbox && Array.isArray(convert_data)
                ? convert_data.join()
                : data.fm_type === fm_types.postcode && Array.isArray(convert_data)
                    ? convert_data.join('')
                    : data.input_assistance === convert_types.add_comma && typeof convert_data === 'string'
                        ? convert_data.replace(/,/g, '')
                        : date_types.includes(data.fm_type) && convert_data !== null && convert_data !== ''
                            ? Moment(convert_data).format('YYYY-MM-DD')
                            : convert_data;
            return { id: data.fm_id, name: data.field_column_name, value: post_value };
        });
    };
    /**
     * API呼び出し共通ファンクション
     * @param is_send_parent post対象の指定
     * @param function_name 呼び出しモジュール名
     * @param pb_id 親棚のid
     * @param cb_id 子棚のid
     * @return void
     */
    var requestModule = function (is_send_parent, function_name, pb_id, cb_id) {
        var post_data = {
            reception_id: reception_id,
            reception_cd: reception_cd,
            status: status_code,
            module_name: function_name,
            detail: convertPostData(is_send_parent, pb_id, cb_id),
            is_json: true,
        };
        postData(post_data, pb_id, cb_id, true, is_send_parent);
    };
    /**
     * APIに値をPOSTする
     *
     * @param post_data postするデータ
     * @param pb_id 親棚のid
     * @param cb_id 子棚のid
     * @param is_send_parent? post対象の指定
     * @param should_loading ローディング表示用フラグ
     */
    var postData = function (post_data, pb_id, cb_id, should_loading, is_send_parent) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    // 通信中の場合はAPIにリクエストをしない
                    if (is_connecting) {
                        return [2 /*return*/];
                    }
                    setIsConnecting(true); // 通信中フラグを立てる
                    setIsLoading(should_loading);
                    return [4 /*yield*/, axios.post('/api/common', post_data)];
                case 1:
                    response = _a.sent();
                    // 正常なレスポンス
                    if (response.data.result) {
                        allocationResponseData(response.data, pb_id, cb_id, is_send_parent, post_data);
                        // 異常なレスポンス
                    }
                    else {
                        showExceptionDialog(response.data.message);
                        setIsLoading(false);
                    }
                    return [3 /*break*/, 4];
                case 2:
                    error_2 = _a.sent();
                    console.error(error_2);
                    jumpUrl(error_2.response.data.url);
                    setIsLoading(false);
                    return [3 /*break*/, 4];
                case 3:
                    setIsConnecting(false); // 通信中フラグを倒す
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    /**
     * レスポンス結果から画面処理を振り分ける
     *
     * @param reasponse_data API返却値
     * @param pb_id 親棚ID
     * @param cb_id 小棚ID
     * @param is_send_parent post対象の指定
     * @param module_name モジュール名
     */
    var allocationResponseData = function (reasponse_data, pb_id, cb_id, is_send_parent, post_data) {
        switch (reasponse_data.response_type) {
            case api_response_type.page_transition: // 画面遷移
                pageTransition(reasponse_data.reception_cd, reasponse_data.reception_id);
                break;
            case api_response_type.dialog: // ダイアログ表示
                showResponseDialog(reasponse_data.detail, pb_id, cb_id, post_data.detail);
                break;
            case api_response_type.validation: // バリデーション
                setValidMessage(reasponse_data.detail, pb_id, cb_id, is_send_parent);
                break;
            case api_response_type.list: // リスト
                showSearchResult(reasponse_data.detail);
                break;
            case api_response_type.auto_input: // 指定項目の自動入力
                setDataAutoInput(reasponse_data.detail);
                break;
            case api_response_type.transition_to_list: // 一覧画面に遷移
                transitionToList();
                break;
            case api_response_type.transition_to_mypage: // マイページ開設同意画面への遷移
                transitionToMypage();
                break;
            case api_response_type.download: // pdfダウンロード
                downloadPdf(post_data.module_name);
                break;
            case api_response_type.auto_input_all: // 複数項目への自動入力
                setDataAutoInputAll(reasponse_data.detail);
                break;
            default:
                break;
        }
    };
    /**
     * 更新された値を使用し、次の詳細画面を表示します。
     * @param reception_cd 案件コード
     * @param reception_id 案件id
     */
    var pageTransition = function (reception_cd, reception_id) {
        setIsLoading(false);
        location.href = "" + location.origin + process.env.MIX_MOCK_URL + "/reception/" + reception_cd + "/" + reception_id;
    };
    /**
     * レスポンスからダイアログを生成する
     * @param response_detail レスポンス値
     * @param pb_id 親棚ID
     * @param cb_id 小棚ID
     */
    var showResponseDialog = function (response_detail, pb_id, cb_id, post_data_detail) {
        var post_data = {
            reception_id: reception_id,
            reception_cd: reception_cd,
            status: status_code,
            module_name: '',
            detail: [],
            is_json: true,
        };
        // 応答結果からボタン押下時のイベントハンドラ作成
        var event_handler = response_detail.btn_function.map(function (function_name, index) {
            if (function_name !== '' && index === dialog_function.yes) {
                post_data.detail = post_data_detail;
            }
            return function_name !== ''
                ? // APIコール
                    function () {
                        post_data.module_name = function_name;
                        postData(post_data, pb_id, cb_id, true);
                        setResponseDialogState(dialog_init);
                    }
                : // モーダルを閉じる
                    function () {
                        setResponseDialogState(dialog_init);
                    };
        });
        // ダイアログの状態を更新
        var dialog_state = {
            is_confirm: response_detail.dialog_type === dialog_type.confirm,
            show: true,
            title: response_detail.dialog_title,
            body: editModalBody(response_detail.dialog_message),
            ClickConfirm: event_handler[dialog_function.confirm],
            ClickYes: event_handler[dialog_function.yes],
            ClickNo: event_handler[dialog_function.no],
        };
        setResponseDialogState(dialog_state);
        setIsLoading(false);
    };
    /**
     * バリデーション結果を画面に表示する
     * メッセージが空の場合は次の棚を開く
     *
     * @param detail バリデーション結果
     * @param pb_id 親棚のid
     * @param cb_id 小棚のid
     * @param is_send_parent post対象の指定
     */
    var setValidMessage = function (details, pb_id, cb_id, is_send_parent) {
        if (details.length === 0) {
            // 現在の棚に属する項目のメッセージを初期化する
            setContents(function (prev) {
                return prev.map(function (value) {
                    return value.pb_id === pb_id && value.cb_id === cb_id
                        ? __assign(__assign({}, value), { message: undefined }) : value;
                });
            });
            // 現在の棚を閉じる
            toggleChildShelf(pb_id, cb_id, false);
            var next_cb_id = findNextChidShelf(cb_id);
            if (next_cb_id !== 0) {
                // 次の棚を開く
                toggleChildShelf(pb_id, next_cb_id, true);
                // 次の棚へスクロールする
                scrollToNextShelf(pb_id, cb_id);
            }
            setIsLoading(false);
            return;
        }
        // 本人確認書類棚対応
        var file_upload_shelf = child_shelfs.find(function (child_shelf) { return child_shelf.cb_kind === shelf_type.documents; });
        if (typeof file_upload_shelf !== 'undefined') {
            for (var _i = 0, details_1 = details; _i < details_1.length; _i++) {
                var detail = details_1[_i];
                // TODO tani.t サーバ側からの返却値が未定のため、detail.form_nameが本人確認書類棚のchild_shelf.keyになる想定で作成。
                if (detail.form_name === file_upload_shelf.key) {
                    // エラーメッセージ表示
                    setFileUploadMessage(detail.message);
                    // 本人確認書類棚を開く
                    toggleChildShelf(file_upload_shelf.pb_id, file_upload_shelf.cb_id, true);
                    // ローディング停止
                    setIsLoading(false);
                    return;
                }
            }
        }
        var _loop_1 = function (detail) {
            // バリデーション項目のindex取得
            var content_index = contents.findIndex(function (content) {
                return content.field_column_name === detail.form_name &&
                    content.disabled === false &&
                    content.pb_id;
            });
            // バリデーション項目を持つ子棚を開く
            toggleChildShelf(pb_id, contents[content_index].cb_id, true);
        };
        for (var _a = 0, details_2 = details; _a < details_2.length; _a++) {
            var detail = details_2[_a];
            _loop_1(detail);
        }
        setContents(function (prev) {
            return prev.map(function (value) {
                // 同じカラム名 & 活性項目のバリデーションメッセージを表示
                var tmp_value = tmp_init;
                for (var _i = 0, details_3 = details; _i < details_3.length; _i++) {
                    var detail = details_3[_i];
                    if (is_send_parent) {
                        // 親棚単位の場合、全体のメッセージを更新する
                        if (value.field_column_name === detail.form_name && !value.disabled) {
                            tmp_value = __assign(__assign({}, value), { message: detail.message });
                            break;
                        }
                        else {
                            tmp_value = __assign(__assign({}, value), { message: undefined });
                        }
                    }
                    else {
                        // 子棚単位の場合、対象の棚に限定してメッセージを更新する
                        if (value.pb_id === pb_id && value.cb_id === cb_id) {
                            if (value.field_column_name === detail.form_name && !value.disabled) {
                                tmp_value = __assign(__assign({}, value), { message: detail.message });
                                break;
                            }
                            else {
                                tmp_value = __assign(__assign({}, value), { message: undefined });
                            }
                        }
                        else {
                            tmp_value = value;
                        }
                    }
                }
                return tmp_value;
            });
        });
        // バリデーション項目にフォーカスイン
        var index = contents.findIndex(function (value) { return !value.disabled && value.field_column_name === details[0].form_name; });
        if (index >= 0) {
            // 郵便番号、チェックボックス、ラジオは対象idに文字列を付与
            var target_id = [fm_types.checkbox, fm_types.postcode].includes(contents[index].fm_type)
                ? "" + contents[index].key + valid_merge_index
                : contents[index].key;
            var target_element = document.getElementById(target_id);
            // 対象elementに合わせて座標移動
            scrollTargetElement(target_element, scroll_option.validation);
            target_element === null || target_element === void 0 ? void 0 : target_element.focus();
        }
        setIsLoading(false);
    };
    /**
     * 検索結果を画面に表示する
     * 件数0：モーダルのみ表示
     * 件数1：自動入力 + モーダル表示
     * 件数2：選択式モーダル表示
     * @param {Array<SearchResult>} details 検索結果
     */
    var showSearchResult = function (details) {
        var dialog_state = {
            title: address_option.title,
            body: '',
            details: details,
            is_confirm: true,
            show: true,
        };
        if (details.length <= 0) {
            dialog_state.body = address_option.undefined_body;
        }
        else if (details.length > 0 && details.length <= 1) {
            // 自動入力
            setContents(function (prev) {
                var target_index = prev.findIndex(function (value) { return value.field_column_name === details[0].form_name && !value.disabled; });
                var array = prev.slice(); // ディープコピー
                array[target_index].value = details[0].value;
                return array;
            });
            var current_index = contents.findIndex(function (value) { return value.field_column_name === details[0].form_name && !value.disabled; });
            dialog_state.body = "" + contents[current_index].fm_display_name + address_option.auto_input_body;
        }
        else {
            dialog_state.is_confirm = false;
        }
        setSearchDialogState(dialog_state);
        setIsLoading(false);
    };
    /**
     * 選択されているアドレスを画面に表示する
     */
    var setSelectAddress = useCallback(function () {
        if (address_state.form_name === '') {
            return;
        }
        setContents(function (prev) {
            var target_index = prev.findIndex(function (value) { return value.field_column_name === address_state.form_name && !value.disabled; }) + 1;
            var array = prev.slice(); // ディープコピー
            array[target_index].value = address_state.value;
            return array;
        });
        setSearchDialogState(search_dialog_init);
        setAddressState({ form_name: '', value: '' });
    }, [address_state]);
    /**
     * 住所の選択状態を変更
     * @param event イベント
     */
    var handleChangeAddress = useCallback(function (event) {
        setAddressState({
            form_name: event.target.name,
            value: event.target.value,
        });
    }, [setAddressState]);
    /**
     * 住所検索情報を初期化
     */
    var clearAddressInfo = useCallback(function () {
        setAddressState(address_init);
        setSearchDialogState(search_dialog_init);
    }, []);
    /**
     * 対応する案件一覧に遷移する
     */
    var transitionToList = function () {
        is_staff
            ? location.replace(process.env.MIX_MOCK_URL + "/staff/list" + location.search)
            : location.replace(process.env.MIX_MOCK_URL + "/mypage/list");
        setTimeout(function () { return setIsLoading(false); }, loding_close_timmer);
    };
    /**
     * 対応するマイページ開設同意確認画面に遷移する
     */
    var transitionToMypage = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    return [4 /*yield*/, axios.post('agreement/store', {
                            reception_cd: reception_cd,
                            reception_id: reception_id,
                        })];
                case 1:
                    response = _a.sent();
                    location.href = response.data.url;
                    return [3 /*break*/, 4];
                case 2:
                    error_3 = _a.sent();
                    console.log(error_3);
                    return [3 /*break*/, 4];
                case 3:
                    setTimeout(function () { return setIsLoading(false); }, loding_close_timmer);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    /**
     * pdfをダウンロードする
     * @param module_name 通信対象モジュール名
     * @return void
     */
    var downloadPdf = function (module_name) { return __awaiter(void 0, void 0, void 0, function () {
        var post_data, start_time, response, end_time, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    post_data = {
                        module_name: module_name,
                        reception_cd: reception_cd,
                        reception_id: reception_id,
                        status: status_code,
                        is_json: false,
                        detail: [],
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    start_time = performance.now();
                    setIsLoading(true);
                    return [4 /*yield*/, axios.post('/api/common', post_data, {
                            responseType: 'blob',
                        })];
                case 2:
                    response = _a.sent();
                    // ファイルダウンロード
                    if (response.headers['content-type'] === content_type.pdf) {
                        //IOS端末かつsafariの場合、ブラウザバック禁止処理を解除してダウンロードしたファイルを表示後に元画面に戻れるようにする。
                        if (isBrowserIOSSafari() || isBrowserIpadSafari()) {
                            releaseBrowzerBack();
                        }
                        fileDownload(response.data, response.headers['content-disposition'], content_type.pdf);
                    }
                    else {
                        // pdf以外許容しないため、ダイアログ表示
                        showExceptionDialog(t('システムエラーが発生しました。'));
                    }
                    end_time = performance.now();
                    setTimeout(function () {
                        setIsLoading(false);
                    }, download_wait_time - (end_time - start_time));
                    return [3 /*break*/, 4];
                case 3:
                    error_4 = _a.sent();
                    setIsLoading(false);
                    console.log(error_4);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    /**
     * エラー発生時、ダイアログを表示する
     *
     * @param message ダイアログ表示メッセージ
     */
    var showExceptionDialog = function (message) {
        // ダイアログの状態を更新
        var dialog_state = {
            is_confirm: true,
            show: true,
            title: '',
            body: editModalBody(message),
            ClickConfirm: function () {
                setResponseDialogState(dialog_init);
            },
        };
        setResponseDialogState(dialog_state);
    };
    /**
     * 該当の項目に対し、バリデーションチェックを実施し、結果を画面に表示する
     * @param id バリデーション対象項目ID
     * @param value バリデーション対象項目入力値
     * @param type 変換タイプ
     * @return boolean バリデーション結果
     */
    var validationCheck = function (id, value, type) { return __awaiter(void 0, void 0, void 0, function () {
        var error_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // 入力値がnull or undefinedの場合、空文字に変換
                    if (value === null || typeof value === 'undefined') {
                        value = '';
                    }
                    if (type === convert_types.add_comma) {
                        value = value.replace(/,/g, ''); // カンマ除去
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, axios.get("/api/check", { params: { id: id, value: value } })];
                case 2:
                    _a.sent();
                    // バリデーションエラーなし
                    setContents(function (prev) {
                        return prev.map(function (value) {
                            return value.fm_id === id && !value.disabled
                                ? __assign(__assign({}, value), { message: undefined }) : value;
                        });
                    });
                    return [2 /*return*/, true];
                case 3:
                    error_5 = _a.sent();
                    // バリデーションエラーあり
                    if (error_5.response.data.statusCode === 422) {
                        setContents(function (prev) {
                            return prev.map(function (value) {
                                return value.fm_id === id && !value.disabled
                                    ? __assign(__assign({}, value), { message: error_5.response.data.message }) : value;
                            });
                        });
                    }
                    else {
                        console.log(error_5.response.data.message); // コンソールにエラーメッセージを表示する
                    }
                    return [2 /*return*/, false];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    /**
     * 該当の項目に対し、文字変換を実施する
     * @param id 文字変換対象項目ID
     * @param value 変換する文字
     * @param type 変換タイプ
     */
    var convertInputData = function (id, value, type) {
        var convert_data = convertData(type, value);
        setContents(function (prev) {
            return prev.map(function (value) {
                return value.fm_id === id && !value.disabled
                    ? __assign(__assign({}, value), { value: convert_data }) : value;
            });
        });
        return convert_data;
    };
    /**
     * 入力履歴ボタンを押下する
     */
    var clickReceptionHistory = function (event) {
        event.preventDefault();
        window.open("" + location.origin + process.env.MIX_MOCK_URL + "/staff/history/" + reception_cd, '_blank', 'top=0,left=0,left=0,width=600,height=600,resizable=yes');
    };
    /**
     * セレクトボックスが変更されたらAPIにリクエストする
     */
    var handleChangeSelected = function (event, content) {
        // functionが設定されてない場合は処理をしない
        if (content.function === null ||
            typeof content.function === 'undefined' ||
            content.function.length === 0) {
            return;
        }
        var value = event.target.value;
        // バリデーションチェック
        validationCheck(content.fm_id, event.target.value, content.input_assistance).then(function (res) {
            // バリデーションを正常通過した場合はAPIをコールする
            if (res) {
                var post_data = {
                    detail: [
                        {
                            id: content.fm_id,
                            name: content.field_column_name,
                            value: value,
                        },
                    ],
                    module_name: content.function,
                    reception_id: reception_id,
                    reception_cd: reception_cd,
                    status: status_code,
                    is_json: true,
                };
                postData(post_data, content.pb_id, content.cb_id, false);
            }
        });
    };
    /**
     * 指定項目に自動入力する
     * @param detail APIレスポンス
     */
    var setDataAutoInput = function (detail) {
        setContents(function (prev) {
            var current_index = prev.findIndex(function (value) { return value.field_column_name === detail.form_name && !value.disabled; });
            var array = prev.slice(); // ディープコピー
            array[current_index].value = detail.message;
            return array;
        });
        setIsLoading(false);
    };
    /**
     * 画面全体に対して、指定項目に自動入力する
     * @param details APIレスポンス
     */
    var setDataAutoInputAll = function (details) {
        setContents(function (prev) {
            return details.reduce(function (previous, detail) {
                var target_index = previous.findIndex(function (value) { return value.field_column_name === detail.form_name; });
                var array = previous.slice(); // ディープコピー
                if (array[target_index]) {
                    array[target_index].value = detail.value;
                }
                return array;
            }, prev);
        });
        setIsLoading(false);
    };
    /**
     * 連打防止：複数回のイベント発火を1回にまとめる
     */
    var joinEventFiredOnce = function (callback) {
        var timer = undefined; // NOTE タイマーは入れ替える可能性があるためletで定義
        setIsLoading(true);
        clearTimeout(timer);
        timer = window.setTimeout(callback, 500);
    };
    /**
     * ファイルアップロード用API呼び出しファンクション
     * ※ファイルアップロード用のみ機能名が空の場合に棚の開閉処理を追加
     *
     * @param is_send_parent post対象の指定
     * @param function_name 機能名
     * @param pb_id 親棚のid
     * @param cb_id 子棚のid
     */
    var requestModuleForFileUpload = function (is_send_parent, function_name, pb_id, cb_id) {
        if (function_name !== '') {
            requestModule(is_send_parent, function_name, pb_id, cb_id);
        }
        else {
            // 現在の棚を閉じる
            toggleChildShelf(pb_id, cb_id, false);
            var next_cb_id = findNextChidShelf(cb_id);
            if (next_cb_id !== 0) {
                // 次の棚を開く
                toggleChildShelf(pb_id, next_cb_id, true);
                // 次の棚へスクロールする
                scrollToNextShelf(pb_id, cb_id);
            }
            setIsLoading(false);
            return;
        }
    };
    /**
     * 排他情報の更新処理
     */
    var updateExclutionInfo = useCallback(function () {
        setExclusionInfo(exclusion_init);
        try {
            axios.put(makePath() + "/exclusion");
        }
        catch (exception) {
            console.log(exception);
        }
    }, []);
    /**
     * パスワードリセットモーダルのイベントハンドラ
     */
    var handleClickPasswordReset = function () {
        // モーダル非表示
        toggleShowPasswordReset();
        var post_data = {
            reception_id: reception_id,
            reception_cd: reception_cd,
            status: status_code,
            module_name: module_name.reset_password,
            detail: [
                {
                    password: password,
                    password_confirmation: password_confirmation,
                },
            ],
            is_json: true,
        };
        postData(post_data, 0, 0, true, false);
    };
    /**
     * 備考登録ボタン押下時処理
     */
    var handleClickPostRemark = function () {
        // 備考欄のデータのみを取得
        var content = contents.find(function (content) { return content.fm_id === remark_field_id; });
        if (content) {
            var post_data = {
                reception_id: reception_id,
                reception_cd: reception_cd,
                status: status_code,
                module_name: module_name.remark,
                detail: [
                    {
                        id: content.fm_id,
                        value: content.value,
                        name: content.field_column_name,
                    },
                ],
                is_json: true,
            };
            postData(post_data, content.pb_id, content.cb_id, true, false);
        }
    };
    return (React.createElement(React.Fragment, null,
        contents.length !== 0 && createParentBlock(),
        React.createElement(ResponseDialog, { is_confirm: response_dialog_state.is_confirm, show: response_dialog_state.show, title: response_dialog_state.title, body: response_dialog_state.body, ClickCallBackYes: response_dialog_state.ClickYes, ClickCallBackNo: response_dialog_state.ClickNo, ClickCallBackConfirm: response_dialog_state.ClickConfirm, t: t }),
        React.createElement(SearchResultDialog, { details: search_dialog_state.details, is_confirm: search_dialog_state.is_confirm, show: search_dialog_state.show, title: search_dialog_state.title, body: search_dialog_state.body, ClickCallBackYes: setSelectAddress, ClickCallBackNo: clearAddressInfo, ClickCallBackConfirm: clearAddressInfo, handleChange: handleChangeAddress }),
        React.createElement(LoadingModal, { show: is_loading }),
        is_staff && React.createElement(FloatingMenu, null),
        React.createElement(ResponseDialog, { is_confirm: false, show: exclusion_info.is_locked, title: t('確認'), body: editModalBody(t("locked_at\u304B\u3089user_name\u30E6\u30FC\u30B6\u304C\u6848\u4EF6\u3092\u958B\u3044\u3066\u3044\u307E\u3059\u3002\u6392\u4ED6\u3092\u89E3\u9664\u3057\u6848\u4EF6\u3092\u958B\u304F\u5834\u5408\u306F\u300C\u306F\u3044\u300D\u3001\u6848\u4EF6\u4E00\u89A7\u753B\u9762\u306B\u623B\u308B\u5834\u5408\u306F\u300C\u3044\u3044\u3048\u300D\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002", { locked_at: exclusion_info.locked_at, user_name: exclusion_info.user_name })), ClickCallBackYes: updateExclutionInfo, ClickCallBackNo: transitionToList, ClickCallBackConfirm: transitionToList, t: t }),
        React.createElement(PasswordReset, { handleChangePassword: handleChangePassword, handleChangePasswordConfirmation: handleChangePasswordConfirmation, handleClick: handleClickPasswordReset, password: password, password_confirmation: password_confirmation, show: show_password_reset, t: t })));
};
var div = document.getElementById('main');
if (div) {
    //Receptionコンポーネント専用のIE対応用クラスを付与する。
    div.classList.add(isBrowserIe() ? 'ie' : 'no-ie');
}
if (document.getElementById('template')) {
    ReactDOM.render(React.createElement(Reception, null), document.getElementById('template'));
}
